import {useParams} from "react-router-dom";
import React, {FormEvent, useState} from "react";
import Form from "../../../components/common/form/Form";
import InputField from "../../../components/common/form/InputField";
import ButtonTray from "../../../components/common/form/ButtonTray";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import {useGetCustomerByIdQuery, useUpdateCustomerMutation} from "../customerApi";
import {handleRTKQuery} from "../../../helpers/utils/RtkQueryUtils";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";

const SuperMarket = () => {
    const {customerId} = useParams();
    const [updateApi, {isLoading: updateApiResponse}] = useUpdateCustomerMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {data: customerData} = useGetCustomerByIdQuery(customerId);
    const [smKey, setSmKey] = useState(customerData !== undefined ? customerData['smKey'] : null);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsModalOpen(true); // Open modal on submit
    };

    const handleConfirmUpdate = async () => {
        // Add update logic here
        const updatedCustomerData = {
            ...customerData,
            smKey:smKey
        };
        await handleRTKQuery(
            () => updateApi({requestBody: updatedCustomerData}).unwrap(),
        );
        setIsModalOpen(false);
    };

    const handleCancel = (e?: React.MouseEvent<HTMLButtonElement>) => {
        e?.preventDefault();
        setSmKey(customerData?.smKey);
    };

    return (
        <div className="mt-3">
            <div className="bg-text-0 p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                <Form onSubmit={handleSubmit} fields={
                    <>
                        <div className="grid grid-cols-12 text-sm">
                            <InputField
                                name="customerId"
                                label="Super Market Key"
                                onChange={(e : any) => {
                                    setSmKey(e.target.value);
                                }}
                                value={smKey}
                                type="text"
                                placeholder="Enter Super Market..."
                                disabled={!hasPermission(["CUST-U"])}
                            />
                        </div>

                        { hasPermission(["CUST-U"]) && <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: handleCancel,
                                        type: "cancel",
                                    },
                                    buttonType: "button"
                                },
                                {
                                    buttonProps: {
                                        btnText: "Update",
                                        type: "submit",
                                    },
                                    buttonType: "button",
                                }
                            ]}
                            align="start"
                            gap={2}
                        />
                        }
                        <ConfirmationModal
                            show={isModalOpen}
                            setShow={setIsModalOpen}
                            title="Update Customer"
                            bodyMessage="Are you sure you want to update this customer?"
                            onSubmit={handleConfirmUpdate}
                            isLoading={updateApiResponse}
                        />
                    </>
                }/>
            </div>
        </div>
    );
};

export default SuperMarket;